import { createModule } from 'vuex-toast'

const toastModule = createModule({ dismissInterval: 8000 })

export default toastModule